import index from './build-page-config';

export default index;
